import { withFormsy } from 'formsy-react';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
class ValidationInput extends Component {
  constructor(props) {
    super(props);
    if (props.value) {
      props.setValue(props.value);
    }
  }
  render() {
    const {
      getValue, id, isPristine, setValue, showError, showRequired, fixedErrorField,
    } = this.props;

    const changeValue = (event) => {
      setValue(event.currentTarget.value);
    };

    const onBlur = (event) => {
      setValue(event.currentTarget.value);
    };
    const errorMessage = this.props.getErrorMessage();
    const invalid = !isPristine() && (showRequired() || showError()); // This is needed so that invalid field errors display on submit.
    const baseDescribedBy = this.props.ariaDescribedBy
      ? this.props.ariaDescribedBy.split(/\s+/).filter(Boolean)
      : [];
    const describedBy = [
      ...baseDescribedBy,
      invalid ? `${id}.errorMessage` : null,
    ]
      .filter(Boolean)
      .filter((value, index, self) => self.indexOf(value) === index)
      .join(' ') || undefined;
    const errorFieldStyle = fixedErrorField
      ? { visibility: invalid ? 'visible' : 'hidden' }
      : { display: invalid ? '' : 'none' };

    return (
      <div
        className={`form__field form-field has-float-label
                ${invalid ? "form-field--invalid" : ""}`}
      >
        <label
          htmlFor={this.props.name}
          className= "form-field__label is-active"
        >
          {this.props.title}
        </label>
        <input
          autoFocus={this.props.autoFocus}
          autoComplete={this.props.autoComplete}
          className={`required attr_check  ${
            invalid ? "form-field__error" : ""
          }`}
          formNoValidate
          id={id}
          maxLength={this.props.maxLength}
          name={this.props.name}
          onBlur={onBlur}
          onChange={changeValue}
          type={this.props.type}
          value={getValue()}
          aria-invalid={invalid}
          aria-describedby={describedBy}
        />
        <div
          id={`${id}.errorField`}
          className="form-field__description"
          style={errorFieldStyle}
        >
          <div
            id={`${id}.errorMessage`}
            htmlFor={id}
            className="validation-error form-field__error"
            style={{ display: "block" }}
            role="alert"
          >
            {errorMessage}
          </div>
        </div>
      </div>
    );
  }
}

ValidationInput.propTypes = {
  autoFocus: PropTypes.bool,
  autoComplete: PropTypes.string,
  ariaDescribedBy: PropTypes.string,
  getErrorMessage: PropTypes.func.isRequired,
  getValue: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  isPristine: PropTypes.func.isRequired,
  maxLength: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired,
  showRequired: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.string,
  fixedErrorField: PropTypes.bool,
  value: PropTypes.string,
};

ValidationInput.defaultProps = {
  autoFocus: null,
  autoComplete: null,
  ariaDescribedBy: null,
  fixedErrorField: false,
  type: 'text',
  value: '',
};

export default withFormsy(ValidationInput);
